export { APP_CONFIG, IAppConfig, appConfig } from './app.config';